import { Form, Input } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import { validationService } from '../../../../services'

const CreateDataSourceContactStep = memo(() => {
  return (
    <>
      <Form.Item
        name="contactName"
        label={t(
          'createDataSourceModal.contactStep.contactName'
        )}
        rules={[
          {
            required: true,
            message: t('errorMessage.isRequired') || '',
          },
        ]}
      >
        <Input
          placeholder={
            t(
              'createDataSourceModal.contactStep.contactNamePlaceHolder'
            ) || ''
          }
        />
      </Form.Item>
      <Form.Item
        label={t(
          'createDataSourceModal.contactStep.contactEmail'
        )}
        name="contactEmail"
        rules={[
          {
            required: true,
            message: t('errorMessage.isRequired') || '',
          },
          {
            validator: validationService.validateEmail,
          },
        ]}
        extra={t(
          'createDataSourceModal.contactStep.contactEmailDescription'
        )}
      >
        <Input
          placeholder={
            t(
              'createDataSourceModal.contactStep.contactEmailPlaceHolder'
            ) || ''
          }
        />
      </Form.Item>
    </>
  )
})

export default CreateDataSourceContactStep
